import React, { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Card, Button, Row, Col, Form, Modal} from "react-bootstrap";
import RendicionesHistoricas from "./rendicionesHistoricas";
import VisarRendicionCuotas from "./visarRendicionCuotas";
import VisarRendicionTotal from "./visarRendicionTotal.js";
import VisarRendicionPie from "./visarRendicionPie.js";
import { LoadingComponent } from 'recupero-comunes';
import { serviceGetCfgForm, serviceGetDeclaracionPago, serviceVisarRendicion, serviceLegalizar } from '../../api/api-visar-rendicion-recupero.js';
import { formato_monto, isValidParam } from '../../common/Formatos'
import { obtenerDatosLlaves } from '../../store/actions/visar-rendicion-recupero-action.js';
import { useFormik } from 'formik'
import { validationSchemaVisarRendicionRecupero } from '../../common/validation-Schemas-visar-rendicion-recupero.js'
import Mensajes from '../mensajes.js'
import { Auth } from 'recupero-comunes';

const VisarRendicionRecupero = () => {

    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 
    const [respuestaVisar, setRespuestaVisar] = useState({});
    const [respuestaLegalizar, setRespuestaLegalizar] = useState({});
    const [respuestaMsg, setRespuestaMsg] = useState({});

    const [deshabilitaNotificar, setDeshabilitaNotificar] = useState(true);
    const [deshabilitaVisar, setDeshabilitaVisar] = useState(true);

    const queryState = JSON.parse(localStorage.getItem('filtrosAreaGestion'))
    const history = useNavigate()
    
    const dispatch = useDispatch()
    const {state} = useLocation()
    const idCaso = state?.row?.IdCaso ? state.row.IdCaso:1298
    const idImplicado = state?.row?.IdImplicado ? state.row.IdImplicado:1
    const idOrganizacionCaso = state?.row?.IdOrganizacionCaso ? state.row.IdOrganizacionCaso:8600399880
    const idFolioRendicion = state?.row?.IdFolioRendicion ? state.row.IdFolioRendicion:159
    const idTrxOrigen = state?.row?.IdTrxOrigen ? state.row.IdTrxOrigen:16631
    const idTarea = state?.row?.IdTarea ? state.row.IdTarea:72
    
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);
    const [declaracionPago, setDeclaracionPago] = useState({});

    const [tipoRendicion, setTipoRendicion] = useState(false);

    const ID_TIPO_RENDICION_INGRESO_TOTAL = 123011;
    const ID_TIPO_RENDICION_INGRESO_CUOTA = 123012;
    const ID_TIPO_RENDICION_INGRESO_PIE_CUOTA = 123013;

    const ID_ESTADO_RENDICION_RENDIDA = 124002;
    
    const data_visar = useSelector((state) => state.visarRendicionRecuperoReducer)
    const {llaves} = data_visar

    const [showModal, setShowModal] = useState(false);
    const [comentarioAnalista, setComentarioAnalista] = useState('');

    const [cuotasRendicion, setCuotasRendicion] = useState([]);


    useEffect(() => {     
    
       dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso, "idFolioRendicion": idFolioRendicion, "idTrxOrigen": idTrxOrigen, "idTarea":idTarea}));
    
    }, [dispatch])

    const initialData = async () => {
        setLoading(true);

        await getCfgForm();
        await getDeclaracionPago();

        setLoading(false);
    }    
    useEffect(() => {     
        initialData(); 
    }, [dispatch])

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrganizacionCaso, idform: 88})).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const getDeclaracionPago = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado:idImplicado, idFolioRendicion: idFolioRendicion })).toString('base64');
        const response = await serviceGetDeclaracionPago(query);

        setDeclaracionPago(response);

        setTipoRendicion(response?.rendicion?.tipoRendicion);

        if (ID_ESTADO_RENDICION_RENDIDA == response?.rendicion?.codEstado) {
            setDeshabilitaVisar(false);
            setDeshabilitaNotificar(true);
        } else {
            setDeshabilitaNotificar(false);
            setDeshabilitaVisar(true);
        }
    }

    useEffect(()=>{
        if(respuestaVisar && respuestaVisar["code"] == 1){
            //setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}),3000)   
            setDeshabilitaNotificar(false);
            setDeshabilitaVisar(true);
            formik.resetForm();   
        }
    },[respuestaVisar])

    useEffect(()=>{
        if(respuestaLegalizar && respuestaLegalizar["code"] == 1){
            setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}),3000)   
        }
    },[respuestaLegalizar])
    

    const notificar = () => {
        try {

            let data = {
                "idCaso": llaves && llaves['idCaso'],
                "idImplicadoCaso": llaves && llaves['idImplicado'],
                "idOrganizacion": llaves && llaves['idOrgCaso'],
                "idUsuario": Auth.currentUser()?.rutUsuario,
                "comentarioAnalista": comentarioAnalista,
                "idRendicionPago": declaracionPago?.rendicion?.idRendicionPago,
                "tipoRendicion": declaracionPago?.rendicion?.tipoRendicion,
                "idFolioConvenioRendicion": declaracionPago?.idFolioRendicion,
                "aliasApp": (llaves && llaves["idTarea"] == 72) ? "VISARENDRECUPE" : "LEGRECDIRECT",
                "idTrxOrigen": llaves && llaves['idTrxOrigen'],
                "cuotasRendicion": cuotasRendicion
            }
            setLoading(true); 
            serviceVisarRendicion(data)
            .then((response) => {

                setRespuestaMsg(response);
                setRespuestaLegalizar(response);
                handleShowToast(true);
                handleCloseModal();
                setLoading(false);                           
            })
            .catch((error) => {
                setLoading(false);
                console.error(error.message);
                alert(error.message);
            });   
        } catch (error) {
            setLoading(false);
            console.error("error: ", error);
        }
    }
    const handleCloseModal = () => {
        setShowModal(false); setComentarioAnalista('');
    }

    const formik = useFormik({
        //YA NO SE USA YA QUE SE LLAMA A VISAR DESDE BOTON DEL MODAL
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idUsuario": ""
        },
        validationSchema: validationSchemaVisarRendicionRecupero(),
        onSubmit: (formData) => {

            const dataForm = {
                ...formData
            }
            dataForm['idCaso'] = llaves && llaves['idCaso'];
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado'];
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso'];
            dataForm['idUsuario'] = Auth.currentUser()?.rutUsuario;
            dataForm['cuotasRendicion'] = cuotasRendicion;
            dataForm['idRendicionPago'] = declaracionPago?.rendicion?.idRendicionPago;
            dataForm['tipoRendicion'] = declaracionPago?.rendicion?.tipoRendicion;
            dataForm['idFolioConvenioRendicion'] = declaracionPago?.idFolioRendicion;
            dataForm['idTrxOrigen'] = llaves && llaves['idTrxOrigen'];
            dataForm['comentarioAnalista'] = comentarioAnalista;

            setLoading(true);            
            try {
                serviceVisarRendicion(dataForm)
                .then((response) => {
                                                
                    setRespuestaVisar(response);
                    setRespuestaMsg(response);
                    handleShowToast(true);
                    setLoading(false);                           
                    getDeclaracionPago();
                })
                .catch((error) => {
                    setLoading(false);
                    console.error(error.message);
                    alert(error.message);
                });   
            } catch (error) {
                setLoading(false);
                console.error("error: ", error);
            }
        }
    })
    return (
        <>
        <Fragment>
        <LoadingComponent show={loading} />
            <Container>
                <Card className="mb-3 p-3">
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-titleing"]) ? cfg_form["rinde-cuotas-titleing"] : 'Visar Rendición Ingreso de Recupero - Caso: '} {llaves && llaves['idCaso']}
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Siniestro'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['siniestro'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Patente'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['patente'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Implicado'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['implicado'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Responsable'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['responsable'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Moneda'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['moneda'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Monto Recobro'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago && isValidParam(declaracionPago['montoRecobro']) ? formato_monto(parseFloat(declaracionPago['montoRecobro'])) : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        { tipoRendicion != ID_TIPO_RENDICION_INGRESO_TOTAL ? (            
                        <Row>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Convenio Pago'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['idConvenio'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Monto Pago (pie)'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago && isValidParam(declaracionPago['montoPagoPie']) ? formato_monto(parseFloat(declaracionPago['montoPagoPie'])) : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Cantidad de Cuotas'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['nroCuotas'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Fecha Primer Pago'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['fechaPrimerPagoFormat'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Fecha Último Pago'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago ? declaracionPago['fechaUltimoPagoFormat'] : null}
                                </Form.Text>
                            </Col>
                            <Col>
                                <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["rinde-cuotas-lbl-siniestro"]) ? cfg_form["rinde-cuotas-lbl-siniestro"] : 'Recobro Cuotas'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {declaracionPago && isValidParam(declaracionPago['totalCuotas']) ? formato_monto(declaracionPago['totalCuotas']) : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        ) : null}
                    </Card.Body>
                </Card>
                { tipoRendicion == ID_TIPO_RENDICION_INGRESO_CUOTA ? (                
                    <>
                    <RendicionesHistoricas 
                        cfg_form = {cfg_form} 
                        declaracionPago={declaracionPago}                        
                    />
                    <VisarRendicionCuotas             
                        cfg_form={cfg_form} 
                        declaracionPago={declaracionPago}
                        cuotasRendicion={cuotasRendicion}
                        setCuotasRendicion={setCuotasRendicion}
                    />
                    </>
                ) : tipoRendicion === ID_TIPO_RENDICION_INGRESO_TOTAL ? (
                    <VisarRendicionTotal
                        cfg_form={cfg_form} 
                        declaracionPago={declaracionPago}
                    />
                ) : tipoRendicion === ID_TIPO_RENDICION_INGRESO_PIE_CUOTA ? (
                    <>
                    <RendicionesHistoricas 
                        cfg_form = {cfg_form} 
                        declaracionPago={declaracionPago}
                    />
                    <VisarRendicionPie
                        cfg_form={cfg_form} 
                        declaracionPago={declaracionPago}
                    />
                    </>
                ) : null}
                
                 {/*<hr style={{ color: '#04005D', height: '1px', marginTop:'-5px' }}></hr>*/}
                 <Card className="mb-3 p-3">
                    <Container>
                        <Row>
                            <Col>
                                {respuestaMsg && 
                                    <Mensajes
                                        showToast={showToast}
                                        handleCloseToast={handleCloseToast}
                                        delay={5000}
                                        responseData={respuestaMsg}
                                    ></Mensajes>
                                }
                            </Col>
                        </Row>
                    </Container>
                    <Form onSubmit={formik.handleSubmit}>
                        <Row className='mt-1'>                    
                            <Col className='d-flex align-items-end justify-content-end m-2'>
                                <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-gestion-compania',{state:{queryState}})}>Volver</Button>
                                <Button className='m-2' disabled={deshabilitaVisar} variant='actualizar' onClick={()=>setShowModal(true)}>Visar Rendición</Button>
                            </Col>
                        </Row>
                    </Form>
                    <hr style={{ color: '#04005D', height: '1px', marginTop:'1px' }}></hr>
                </Card>
                <Modal show={showModal} onHide={handleCloseModal} centered>                   
                    <Card>
                        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                            Notifica Legalización de Recupero
                        </Card.Header>
                        <Card.Body>
                            <Row>
                            <Col md='12' className='mt-2'>
                                <Form.Label className='mb-0 mt-2 is_required'>
                                    Comentario Analista (se incluye en el correo)
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    className='mt-2 mb-3'
                                    name='comentarioAnalista'
                                    value={comentarioAnalista}
                                    onChange={(e) => setComentarioAnalista(e.target.value)}
                                />
                            </Col>
                        </Row>
                        </Card.Body>
                        <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant='outline-info' onClick={handleCloseModal}>Cerrar</Button>
                             &nbsp;
                            <Button variant='actualizar' onClick={notificar}>Enviar</Button>
                        </Card.Footer>
                    </Card>
                </Modal>
            </Container>
        </Fragment>
        <style type='text/css'>
                {`
                .btn-carpeta {
                    background-color: #F0AD3E;
                    color: #FFFFFF;
                    width: 140px;
                }
                .btn-carpeta:hover{
                    background-color:#e1b97f;
                    color: #FFFFFF;
                }
                .btn-actualizar {
                    background-color: #C14B49;
                    color: #FFFFFF;
                    width: 140px;
                    padding:6px 0px 6px 0px;
                }
                .btn-actualizar:hover{
                    background-color:  #F6897E;
                    color: #FFFFFF;
                }
                .btn-volver {
                    color: #66CCCC;
                    border: 1px solid #C00
                    width: 140px;
                }
                .btn-notificar {
                    background-color:rgb(63, 106, 170);
                    color: #FFFFFF;
                    width: 140px;
                    padding:6px 0px 6px 0px;
                }
                .btn-notificar:hover{
                    background-color:rgb(73, 139, 193);
                    color: #FFFFFF;
                }
            `}
        </style>
    </>
    );
};
export default VisarRendicionRecupero;